import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import OverlaySpinner from "core/ui/OverlaySpinner";
import Button from "core/ui/Button";

const SoldOutModal = loadable(() => import("./SoldOutModal"), {
	fallback: <OverlaySpinner />
});

const SoldOut = ({
	soldOutNotifRequested,
	soldOutError,
	toggleSoldOutReminderModal,
	onChangeSoldOut,
	soldOutModalOpen,
	submitSoldOutReminder,
	reminderEmail,
	marketingOptIn
}) => (
	<>
		<Button
			size="lg"
			fullWidth
			disabled={soldOutNotifRequested}
			onClick={toggleSoldOutReminderModal}
		>
			{soldOutNotifRequested
				? "We'll notify you when it's back"
				: "Notify me when available"}
		</Button>
		<SoldOutModal
			modalOpen={soldOutModalOpen}
			errors={soldOutError}
			onClose={toggleSoldOutReminderModal}
			onChange={onChangeSoldOut}
			onSubmit={submitSoldOutReminder}
			existingReminder={soldOutNotifRequested}
			reminderEmail={reminderEmail}
			marketingOptIn={marketingOptIn}
		/>
	</>
);

SoldOut.propTypes = {
	soldOutModalOpen: PropTypes.bool,
	toggleSoldOutReminderModal: PropTypes.func,
	onChangeSoldOut: PropTypes.func,
	submitSoldOutReminder: PropTypes.func,
	soldOutError: PropTypes.object,
	soldOutNotifRequested: PropTypes.bool,
	reminderEmail: PropTypes.string,
	marketingOptIn: PropTypes.bool,
};

export default SoldOut;
